/*Generated from the `:::slide{key="976a9c7c-e4d3-45de-9299-820de43f37df" slug="ch-sh-zh-initials"}` (simplified/001-P1/008/山.mdx) directive. Edit the lesson or level file.*/
import {useMDXComponents} from "@bacons/mdx";
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
function _createMdxContent(props) {
  const components = {
    ...useMDXComponents(),
    ...props.components
  };
  const {SlidePageBlock, ...html} = components;
  if (!SlidePageBlock) _missingMdxReference("SlidePageBlock", true);
  if (!html) _missingMdxReference("html", false);
  if (!html.em) _missingMdxReference("html.em", true);
  if (!html.p) _missingMdxReference("html.p", true);
  if (!html.strong) _missingMdxReference("html.strong", true);
  if (!html.table) _missingMdxReference("html.table", true);
  if (!html.tbody) _missingMdxReference("html.tbody", true);
  if (!html.td) _missingMdxReference("html.td", true);
  if (!html.th) _missingMdxReference("html.th", true);
  if (!html.thead) _missingMdxReference("html.thead", true);
  if (!html.tr) _missingMdxReference("html.tr", true);
  return _jsxs(_Fragment, {
    children: [_jsx(SlidePageBlock, {
      block: "0",
      section: "0",
      kind: "p",
      keepWithNext: "true",
      count: "2",
      children: _jsx(html.p, {
        children: "Most initials are a single consonant letter except for these three:",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "1",
      section: "0",
      kind: "table",
      count: "2",
      children: _jsxs(html.table, {
        children: [_jsx(html.thead, {
          children: _jsxs(html.tr, {
            children: [_jsx(html.th, {
              children: "Initial",
              components: html
            }), _jsx(html.th, {
              children: "English sound",
              components: html
            })]
          }),
          components: html
        }), _jsxs(html.tbody, {
          children: [_jsxs(html.tr, {
            children: [_jsx(html.td, {
              children: _jsx(html.em, {
                children: "ch",
                components: html
              }),
              components: html
            }), _jsxs(html.td, {
              children: ["\"ch\" in \"", _jsx(html.strong, {
                children: "ch",
                components: html
              }), "urch\""]
            })]
          }), _jsxs(html.tr, {
            children: [_jsx(html.td, {
              children: _jsx(html.em, {
                children: "sh",
                components: html
              }),
              components: html
            }), _jsxs(html.td, {
              children: ["\"sh\" in \"", _jsx(html.strong, {
                children: "sh",
                components: html
              }), "irt\""]
            })]
          }), _jsxs(html.tr, {
            children: [_jsx(html.td, {
              children: _jsx(html.em, {
                children: "zh",
                components: html
              }),
              components: html
            }), _jsxs(html.td, {
              children: ["\"j\" in \"", _jsx(html.strong, {
                children: "j",
                components: html
              }), "ury\""]
            })]
          })]
        })]
      }),
      components: html
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
